import { useId } from 'react';
import type { CustomFieldProps } from './types';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Icons } from '@/components/icons';
import { CustomFieldHelperText } from './custom-field-helper-text';
import { CustomFieldLabel } from './custom-field-label';
import { CustomFieldWrapper } from './custom-field';

export function CustomSelectField({
  title,
  placeholder,
  onValueChange,
  value,
  disabled,
  required,
  description,
  options,
  error,
}: CustomFieldProps) {
  const id = useId();
  const handleClear = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onValueChange?.('');
  };
  return (
    <CustomFieldWrapper>
      <CustomFieldLabel required={required} htmlFor={id}>
        {title}
      </CustomFieldLabel>
      <div className='relative'>
        <Select value={value} onValueChange={onValueChange} disabled={disabled}>
          <SelectTrigger
            id={id}
            data-has-value={value !== ''}
            className='data-[has-value=false]:text-muted-foreground/70'
          >
            <SelectValue placeholder={placeholder || title} />
          </SelectTrigger>
          {value && !required && !disabled && (
            <button
              type='button'
              onClick={handleClear}
              className='absolute top-1/2 right-8 -translate-y-1/2 rounded-full p-1 hover:bg-accent focus:ring-2 focus:ring-ring focus:outline-hidden'
              aria-label='Clear selection'
            >
              <Icons.close size={16} className='text-muted-foreground' />
            </button>
          )}
          <SelectContent>
            {options?.map((option) => (
              <SelectItem key={option} value={option}>
                {option}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <CustomFieldHelperText error={error} description={description} />
    </CustomFieldWrapper>
  );
}
